<template>
    <el-form
        :model="form"
        :rules="rules"
        ref="repairForm"
        label-width="140px">
        <!-- 状态 -->
        <el-form-item
            :label="$t('message.repair.form1')"
            v-if="!is_add">
            <div>{{{val: form.status, lang: $t('message.repair')} | repair_status}}</div>
        </el-form-item>
        <!-- 回复 -->
        <el-form-item
            :label="$t('message.repair.form2')"
            v-if="!is_add">
            <div v-html="form.reply"></div>
            <!-- <el-input 
                v-model="form.reply"
                type="textarea"
                :rows="2"
                :disabled="!is_add">
            </el-input> -->
        </el-form-item>
        <!-- 机器名称 -->
        <el-form-item
            :label="$t('message.repair.form3')"
            prop="pro_id">
            <el-select
                v-model="form.pro_id"
                :disabled="!is_add">
                <el-option
                    v-for="(item, index) in service_goods"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- 机身号码 -->
        <el-form-item
            :label="$t('message.repair.form4')"
            prop="">
            <el-input v-model="form.type" :disabled="!is_add"></el-input>
        </el-form-item>
        <!-- 机身号码 -->
        <el-form-item
            :label="$t('message.repair.form5')"
            prop="">
            <el-input v-model="form.number" :disabled="!is_add"></el-input>
        </el-form-item>
        <!-- 是否我司购买 -->
        <el-form-item
            :label="$t('message.repair.form6')"
            prop="this_website">
            <el-radio v-model="form.this_website" label="0" :disabled="!is_add">{{$t("public.radio1")}}</el-radio>
            <el-radio v-model="form.this_website" label="5" :disabled="!is_add">{{$t("public.radio2")}}</el-radio>
        </el-form-item>
        <template v-if="form.this_website == '0'">
            <!-- 公司名称 -->
            <el-form-item
                :label="$t('message.repair.form7')"
                prop="companyname">
                <el-input v-model="form.companyname" :disabled="!is_add"></el-input>
            </el-form-item>
            <!-- 发票号码 -->
            <el-form-item
                :label="$t('message.repair.form8')"
                prop="">
                <el-input v-model="form.invoice_number" :disabled="!is_add"></el-input>
            </el-form-item>
            <!-- 购买日期 -->
            <el-form-item
                :label="$t('message.repair.form9')"
                prop="">
                <el-date-picker
                    v-model="form.buy_day"
                    type="date"
                    :disabled="!is_add">
                </el-date-picker>
            </el-form-item>
            <!-- 是否有维修过 -->
            <el-form-item
                :label="$t('message.repair.form10')"
                prop="is_repair">
                <el-radio-group 
                    v-model="form.is_repair"
                    :disabled="!is_add">
                    <el-radio label="5">{{$t("public.radio1")}}</el-radio>
                    <el-radio label="10">{{$t("public.radio2")}}</el-radio>
                    <el-radio label="0">{{$t("message.repair.radio")}}</el-radio>
                </el-radio-group>
            </el-form-item>
        </template>
        <!-- 联系人 -->
        <el-form-item
            :label="$t('message.repair.form11')"
            prop="contact">
            <el-input v-model="form.contact" :disabled="!is_add"></el-input>
        </el-form-item>
		<!-- 电子邮箱 -->
		<el-form-item
		    :label="$t('message.repair.form15')"
		    prop="email">
		    <el-input v-model="form.email" :disabled="!is_add"></el-input>
		</el-form-item>
        <!-- 联系电话 -->
        <el-form-item
            :label="$t('message.repair.form12')"
            prop="phone">
            <el-input v-model="form.phone" :disabled="!is_add"></el-input>
        </el-form-item>
        <!-- 地址 -->
        <el-form-item
            :label="$t('message.repair.form13')"
            prop="address">
            <el-input 
                v-model="form.address"
                type="textarea"
                :rows="2"
                :disabled="!is_add">
            </el-input>
        </el-form-item>
        <!-- 维修原因 -->
        <el-form-item
            :label="$t('message.repair.form14')"
            prop="reason">
            <el-input 
                v-model="form.reason"
                type="textarea"
                :rows="2"
                :disabled="!is_add">
            </el-input>
        </el-form-item>
        <!-- 我已阅读并同意 -->
        <el-form-item v-if="is_add">
            <el-checkbox v-model="form.isSure">{{$t("message.register.forSure")}}</el-checkbox>
            <el-button
                type="text"
                @click="handleAgreement">
                《{{$t('message.register.agreement')}}》
            </el-button>
        </el-form-item>
        <!-- 提交 -->
        <el-form-item
            v-if="is_add">
            <el-button
                type="primary"
                @click="handleClick(form)">
                {{$t("public.submitBtn")}}
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
    filters: {
        repair_status({val,lang}){
            switch (val) {
                case "0":
                    return lang.filter1;
                    break;
                case "10":
                    return lang.filter2;
                    break;
                case "20":
                    return lang.filter3;
                    break;
                case "30":
                    return lang.filter4;
                    break;
            }
        }
    },
    data() {
        return {
            form: {
                status: "", // 维修单状态
                reply: "", // 后台回复
                pro_id: "", // 維修商品ID
                type: "", // 機器型號
                number: "", // 機身號碼
                this_website: "0", // 是否在本公司上購買:0=是,5=否
                companyname: "", // 公司名称
                invoice_number: "", // 發票號碼
                buy_day: "", // 購買日期
                is_repair: "5", // 是否維修過:0=不清楚,5=是,10=否	
                contact: "", // 聯繫人
                phone: "", // 電話
                email: "", // 郵箱
                reason: "", // 原因
                reply: "", // 回復
                address: "",  // 地址
                isSure: false
            },
            rules: {
                pro_id: [
                    { required: true, message: this.$t("message.repair.rule1"), trigger: 'blur' }
                ],
                this_website: [
                    { required: true, message: this.$t("message.repair.rule2"), trigger: 'blur' }
                ],
                companyname: [
                    { required: true, message: this.$t("message.repair.rule3"), trigger: 'blur' }
                ],
                is_repair: [
                    { required: true, message: this.$t("message.repair.rule4"), trigger: 'blur' }
                ],	
                contact: [
                    { required: true, message: this.$t("message.repair.rule5"), trigger: 'blur' }
                ],
				email: [
				    { required: true, message: this.$t("message.repair.rule10"), trigger: 'blur' }
				],
                phone: [
                    { required: true, message: this.$t("message.repair.rule6"), trigger: 'blur' }
                ],
                reason: [
                    { required: true, message: this.$t("message.repair.rule7"), trigger: 'blur' }
                ],
                address: [
                    { required: true, message: this.$t("message.repair.rule8"), trigger: 'blur' }
                ],
                isSure: [
                    { required: true, message: this.$t("message.repair.rule9"), trigger: 'blur' }
                ]
            }
        }
    },
    props: {
        handleSubmit: Function,
        repairDetail: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    computed: mapState({
        service_goods: state => state.other.service_goods,
        is_add(){
            let detail = this.repairDetail;
            return detail.id? false: true;
        }
    }),
    methods: {
        ...mapMutations([
            "handleDialog"
        ]),
        ...mapActions([
            "getRepairAgreement"
        ]),
        handleAgreement(){ // 打开协议条款
            this.getRepairAgreement();
            this.handleDialog(true);
        },
        setFrom(val){
            this.form = {
                status: val.status,
                reply: val.reply,
                pro_id: val.pro_id,
                type: val.type, 
                number: val.number,
                this_website: val.this_website,
                companyname: val.companyname,
                invoice_number: val.invoice_number,
                buy_day: val.buy_day,
                is_repair: val.is_repair,
                contact: val.contact,
                phone: val.phone,
                email: val.email,
                reason: val.reason,
                reply: val.reply,
                address: val.address
            }
        },
        clearForm(){
            this.form = {
                status: "",
                reply: "",
                pro_id: "",
                type: "", 
                number: "",
                this_website: "",
                companyname: "",
                invoice_number: "",
                buy_day: "",
                is_repair: "",
                contact: "",
                phone: "",
                email: "",
                reason: "",
                reply: "",
                address: ""
            }
        },
        handleClick(form){
            this.$refs.repairForm.validate((valid) => {
                if(valid){
                    this.handleSubmit({
                        pro_id: form.pro_id,
                        type: form.type,
                        number: form.number,
                        this_website: form.this_website,
                        invoice_number: form.invoice_number,
                        buy_day: form.buy_day,
                        is_repair: form.is_repair,
                        contact: form.contact,
                        phone: form.phone,
                        email: form.email,
                        reason: form.reason,
                        address: form.address,
                        companyname: form.companyname
                    }).then(res => {
                        // if(res.type){
                        //     this.$message({
                        //         showClose: true,
                        //         message: "提交成功！",
                        //         type: "success"
                        //     })
                        // }else{
                        //     this.$message({
                        //         showClose: true,
                        //         message: "提交失敗！",
                        //         type: "error"
                        //     })
                        // }
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: res.type? "success": "error"
                        })
                        if(res.type) this.clearForm();
                    })
                }
            })
        }
    },
    mounted() {
        if(this.repairDetail.id) this.setFrom(this.repairDetail);
    },
    watch: {
        repairDetail: {
            handler: "setFrom",
            immediate: true
        }
    },
}
</script>

<style scoped>

</style>